<p-blockui [blocked]="parent?.isBusy()">
  <div class="progress-spinner">
    <p-progressSpinner></p-progressSpinner>
  </div>
</p-blockui>

<div *ngIf="!parent.isPageReady" class="flex flex-col h-full w-full">
  <p-progressSpinner ariaLabel="loading" />
</div>


<div *ngIf="parent.isPageReady" class="flex flex-col h-full w-full">
  <div class="grow w-full flex flex-col min-h-0">
    <p-confirmDialog [closable]="false" [key]="parent.dialogKey" [baseZIndex]="1000"></p-confirmDialog>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>

  <div class="flex mt-2 w-full">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </div>
</div>